<template>
<div class="regpage">
   <v-container fill-height>
        <v-row justify-center>
            <v-col cols="10" class="mx-auto">
              <!-- <v-alert
               v-model="successMessage"
                  prominent
                  type="success"
                  dismissible
               >
                  <v-row align="center">
                  <v-col class="grow">
                     User was successfully created. An email was sent to {{this.userData.Email}}. Please verify to complete registration. 
                  </v-col>
                  </v-row>
               </v-alert> -->
               <v-alert
                  v-model="errorsMessage"
                  prominent
                  type="error"
                  dismissible
               >
                  <v-row align="center">
                  <v-col class="grow">
                     Opps something went wrong {{ this.errorMessage }}
                  </v-col>
                  <!-- <v-col class="shrink">
                     <v-btn>Take action</v-btn>
                  </v-col> -->
                  </v-row>
               </v-alert>
           </v-col>
            <v-col cols="12" class="text-center">
                <v-card
                    elevation="2"
                    max-width="500"
                    class="mx-auto my-auto py-4 px-4 myregcard"
                >   
                <v-row>
                    <v-col class="col-12 text-center">
                        <v-img src="../assets/africanring.jpeg" width="200px" class="mx-auto"/>
                    </v-col>
                </v-row>
                <h1 class="white--text">
                    Register
                </h1>
                <v-form ref="form" v-model="valid">
                    <v-text-field
                    dark
                    :rules="[rules.required]"
                    v-model="userData.Username"
                    label="Username"
                 ></v-text-field>
                 <v-text-field
                  dark
                    :rules="[rules.required]"
                    v-model="userData.Name"
                    label="Name"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Surname"
                    label="Surname"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Email"
                    label="Email"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Mobile"
                    label="Phone"
                 ></v-text-field>
                 <!-- <v-text-field
                    :rules="[rules.required]"
                    v-model="userData.Mobile"
                    label="Phone"
                 ></v-text-field> -->
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.password"
                    label="Password"
                    type="password"
                 ></v-text-field>
                    <v-btn
                    class="ma-2 white--text"
                    :loading="loading"
                    :disabled="!valid"
                    @click="registerUser()"
                    color="red"
                    >
                    Register User
                    </v-btn>
                </v-form>
                <v-btn
                    class="ma-2 white--text"
                    color="red"
                    @click="loginpage()"
                    >
                    Login
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
import firebase from 'firebase/compat/app';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {setDoc, doc } from "firebase/firestore"; 
import db from '../firebaseConfig'
// import db from '../firestore'

export default {
    data: () => ({
        loading: false,
        valid: false,
        rules: {
            required: value => !!value || 'Required.',
        },
        userData: {
               Name: '',
               Surname: '',
               Username: '',
               Date:'',
               Role:'',
               Mobile:'',
               Email: '',
               password: '',
               Status:'',
               image:''
            },
            successMessage: false,
            errorsMessage: false,
            errorMessage:'',
    }),
    methods:{
        loginpage() {
            this.$router.replace('login');
        },
        validate () {
        this.$refs.form.validate()
      },
        registerUser(){
            this.loading = true
            const auth = getAuth()
            createUserWithEmailAndPassword(auth, this.userData.Email, this.userData.password)
               .then(() => {
                  firebase.auth().currentUser.updateProfile({
                     displayName: this.userData.Username
                  }).then(() => {
                        this.successMessage = true
                        // let emailsent = true
                        // this.store.commit('Set_verifiyemailaddress', emailsent)
                        this.verifiyEmail()
                  }).catch(err => {
                     this.errorsMessage = true
                     this.loading = false
                     this.errorMessage = err.message;
                  });
               }).catch(err => {
                  this.errorsMessage = true
                  this.loading = false
                  this.errorMessage = err.message
               });
         },
         verifiyEmail(){
            // this.store.commit('Set_verifiyemailaddress', emailsent)
               const user = firebase.auth().currentUser
                  const actionCodeSettings = {
                  url: `http://localhost:8080/sign-in/?email=${user.email}`,
                  };
               user.sendEmailVerification(actionCodeSettings);
               this.adduserinfo()
         },
         async adduserinfo(){
            this.successMessage = false
          try {
                // this.loading = true
                // var date = date.now()
                let date = new Date();
                const superadmin = "superadmin"
                const newUser = firebase.auth().currentUser


                await setDoc(doc(db, "users", newUser.uid), {
                    Username: this.userData.Username,
                    Name: this.userData.Name,
                    Surname: this.userData.Surname,
                    Email: this.userData.Email,
                    Phone: this.userData.Mobile,
                    Role: superadmin,
                    Status: 'Active',
                    image: null,
                    Date: date.toLocaleString('en-US', {
                        weekday: 'short', // long, short, narrow
                        day: 'numeric', // numeric, 2-digit
                        year: 'numeric', // numeric, 2-digit
                        month: 'long', // numeric, 2-digit, long, short, narrow
                        hour: 'numeric', // numeric, 2-digit
                        minute: 'numeric', // numeric, 2-digit
                        second: 'numeric', // numeric, 2-digit
                    })
                });
                console.log(`Doc Was Successfully Created`);
                this.loading = false
                // this.loading = false
                // this.getusers()
                // this.loading = false
                } catch (e) {
                console.error("Error adding document: ", e);
                }
      },
    }
}
</script>

<style lang="sass">
.regpage 
  background-image: url("../assets/boxingbg.jpeg")
  background-size: cover
  background-repeat: no-repeat
  background-position-x: center
  height: 100%!important

.myregcard 
  background-color: #000000!important
</style>